import { render, staticRenderFns } from "./OverviewTable.vue?vue&type=template&id=96127d72&scoped=true&"
import script from "./OverviewTable.vue?vue&type=script&lang=js&"
export * from "./OverviewTable.vue?vue&type=script&lang=js&"
import style0 from "./OverviewTable.vue?vue&type=style&index=0&id=96127d72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96127d72",
  null
  
)

export default component.exports